export const ROLES = {
  STAFF: 'staff',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
} as const;

export const ACCOUNT_STATUS = {
  PENDING_APPROVAL: 'pending_approval',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  DEACTIVATED: 'deactivated',
} as const;

export const ATTENDANCE_STATUS = {
  CLOCKED_IN: 'clocked_in',
  CLOCKED_OUT: 'clocked_out',
  INCOMPLETE: 'incomplete',
  MISSED_CLOCK_IN: 'missed_clock_in',
  MISSED_CLOCK_OUT: 'missed_clock_out',
} as const;

export const LATE_CATEGORY = {
  ON_TIME: 'on_time',
  WITHIN_GRACE: 'within_grace',
  LATE: 'late',
  VERY_LATE: 'very_late',
} as const;

export const DEDUCTION_TYPE = {
  LATE_ARRIVAL: 'late_arrival',
  EXTRA_LATE: 'extra_late',
  MISSED_CLOCK_OUT: 'missed_clock_out',
  MISSED_CLOCK_IN: 'missed_clock_in',
} as const;

export const DEPARTMENTS = [
  'Laboratory',
  'Radiology',
  'Pharmacy',
  'Reception',
  'Finance',
  'Administration',
  'IT',
  'Maintenance',
] as const;

export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
] as const;

export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters',
  'At least one uppercase letter',
  'At least one lowercase letter',
  'At least one number',
  'At least one special character (!@#$%^&*)',
];

export const WEBCAM_CONSTRAINTS = {
  width: 640,
  height: 480,
  facingMode: 'user',
};
